import React, { useState, useContext } from 'react'
import moment from 'moment'
import { useHistory } from 'react-router-dom'

import Text from 'components/Text'
import ButtonNext from 'components/ButtonNext'
import Input from 'components/Input'

import { Context } from 'hooks/AccountValidation'
import { useToast } from 'hooks/toast'

import { ReactComponent as BackIcon } from 'assets/icons/ic-backarrow.svg'

import * as s from './styles'

const DefineBirthDate = () => {
  const { setCurrentStep, formData, setFormData } = useContext(Context)
  const [birthDate, setBirthDate] = useState({
    value: '',
    isValid: false,
    touched: false
  })

  const [loading, setLoading] = useState(false)

  const { addToast } = useToast()
  
  const history = useHistory()

  async function handleNext() {
    setLoading(true)
    try {
      
      if (validateAge(birthDate.value)) {
        setFormData({ ...formData, birthDate: moment(birthDate.value, "DD/MM/YYYY").toISOString() })
        setLoading(false)
        setCurrentStep('EMAIL')
      } else {
        history.push({ pathname: '/validacao-idade', state: { logoff: true }})
      }
    } catch (error) {
      setLoading(false)
      addToast({
        title: '',
        description: '',
        type: 'error'
      })
    }
  }

  const validateBirthDate = (str: string) => {
    const splited = str.split('/');
    const validInput = !isNaN(Number(splited[0])) && !isNaN(Number(splited[1])) && !isNaN(Number(splited[2]));
    const date = moment(str, "DD/MM/YYYY");
    return validInput && date.isValid() && date.isAfter(moment().add('years', -120)) && date.isBefore(moment());
  }

  const validateAge = (str: string) => {
    const date = moment(str, "DD/MM/YYYY");
    return date.isValid() && date.isBefore(moment().add('years', -18))
  }

  return (
    <s.Page>
      <s.Header>
        <s.ContainerTop>
          <BackIcon
            width={30}
            height={30}
            fill="white"
            onClick={() => {
              setCurrentStep('PHONE_NUMBER') // setCurrentStep('CARDNUMBER_QUESTION')
            }}
          />
        </s.ContainerTop>
        <s.HeaderDescriptionContainer>
          <Text color="white" type="h2_semibold">
            Qual a sua data de nascimento?
          </Text>
        </s.HeaderDescriptionContainer>
      </s.Header>
      <s.Content>
        <Input
          label="Data de nascimento"
          mask="99/99/9999"
          value={birthDate.value}
          onChange={({ target }) => {
            setBirthDate({
              ...birthDate,
              value: target.value,
              isValid: validateBirthDate(target.value),
              touched: true
            })
          }}
          hasError={!birthDate.isValid && birthDate.touched}
          errorMessage="Digite um data de nascimento válida"
        />
        <s.FooterContainer>
          <ButtonNext
            isLoading={loading}
            disabled={!birthDate.isValid}
            onClick={handleNext}
          />
        </s.FooterContainer>
      </s.Content>
    </s.Page>
  )
}

export default DefineBirthDate
